module.exports = __webpack_public_path__ + "img/info-circle.aac5a4a3.svg";